var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMesialRotation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 1.91667V1H18V1.91667H17ZM17 5.58333V3.75H18V5.58333H17ZM17 9.25V7.41667H18V9.25H17ZM17 12.9167V11.0833H18V12.9167H17ZM17 16.5833V14.75H18V16.5833H17ZM17 20.25V18.4167H18V20.25H17ZM17 23V22.0833H18V23H17Z",
    fill: "#647B8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 5.92092C15.87 5.10979 13.9349 4.99999 11.9999 5C8.82483 5.00001 5.64983 5.29564 6.03125 8.5C6.04199 8.59025 6.05275 8.68082 6.06353 8.77168C6.62496 13.5009 7.27778 19 11.3263 19H12.6737C15.0942 19 16.3009 17.0343 17 14.4427V5.92092Z",
    fill: "#C9D2D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99927 8.01953C4.58721 8.30195 3.25277 8.93098 2.59181 9.85641C1.90353 10.8201 1.81768 11.9977 2.35506 13.0724C2.87181 14.1058 3.91418 14.9596 5.33526 15.5489C6.76721 16.1426 8.65393 16.5001 10.9993 16.5001V18.5001L14.9993 15.5001L10.9993 12.5001V14.5001C8.8449 14.5001 7.23179 14.1701 6.10129 13.7014C4.95989 13.2281 4.37719 12.6445 4.14387 12.1779C3.93116 11.7525 3.97021 11.3676 4.21934 11.0188C4.49579 10.6317 5.10743 10.1983 6.19535 9.98069L5.99927 8.01953Z",
    fill: "#647B8F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMesialRotation);
export default __webpack_public_path__ + "static/media/mesial-rotation.26e09836.svg";
export { ForwardRef as ReactComponent };